import ErrorIcon from '@mui/icons-material/Error';
import { Typography } from '@mui/material';

import { BUTTON_TEXT } from 'portal/src/constants/button-text';

import ConfirmDialog from '../ConfirmDialog';

const ConfirmCancelDialog = ({
  showDialog,
  onConfirmCancel,
  onKeepFormState,
}: {
  showDialog: boolean;
  onConfirmCancel: () => void;
  onKeepFormState: () => void;
}) => (
  <ConfirmDialog
    open={showDialog}
    message={
      <Typography>
        Are you sure you want to cancel?
        <br />
        All unsaved changes will be lost.
      </Typography>
    }
    onClose={onKeepFormState}
    onPrimaryButtonClicked={onConfirmCancel}
    onSecondaryButtonClicked={onKeepFormState}
    primaryButtonLabel={BUTTON_TEXT.confirmCancel}
    secondaryButtonLabel={BUTTON_TEXT.doNotCancel}
    renderElement={<ErrorIcon sx={{ color: 'red' }} />}
    secondaryButtonDisabled={false}
  />
);

export default ConfirmCancelDialog;
